import React from "react";
import mainStyle from "../../dashboard.module.scss";
import { styled, useTheme } from "@mui/material/styles";
import { Box, Typography, Button, List, ListItem } from "@mui/material";
// import { useNavigate } from "react-router-dom";
import icn_grid_chart from "assets/images/icons/icn_grid_chart.svg";
import { mockEvents } from "../../const";

const PlayButtonContainer = styled(Box)(({ theme }) => ({
  width: "44px",
  height: "44px",
  borderRadius: "8px",
  backgroundColor: theme.palette.primary.greyThread || "#F0F0F0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  transition: "all 0.2s ease-in-out",
  flexShrink: 0,
  "&:hover": {
    backgroundColor: theme.palette.primary.lightBlue || "#E3F2FD",
    transform: "scale(1.05)",
  },
}));

const PlayIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 5V19L19 12L8 5Z" fill="#1976D2" />
  </svg>
);

const EventLog = ({ sortable, events = mockEvents }) => {
  const theme = useTheme();
  // const navigate = useNavigate();

  return (
    <Box
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
      className={`main-card-content ${mainStyle["dndObj_card"]} ${
        sortable === true ? mainStyle["dndObj_edit"] : ""
      }`}
    >
      <Box className={mainStyle["dndObj_title"]} sx={{ display: "flex", alignItems: "center" }}>
        <img src={icn_grid_chart} alt="event_log_icon" />
        <Typography component="span" sx={{ marginLeft: "10px" }}>Event Log</Typography>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 2, mt: 1.5 }}>
        <Typography sx={{ fontWeight: "bold", fontSize: "14px", color: "text.primary" }}>
          Latest Events
        </Typography>
        <Button
          size="small"
          sx={{
            textTransform: "none",
            fontSize: "14px",
            fontWeight: "bold",
            color: "#172664",
            background: "none !important",
            boxShadow: "none !important",
            border: "none !important",
            padding: 0,
            minWidth: "auto",
            "&:hover": {
              background: "none !important",
              textDecoration: "underline",
            },
          }}
          // onClick={() => navigate("/surveillance/events")}
        >
          All Events &gt;
        </Button>
      </Box>

      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          px: 2,
          py: 1,
          "&::-webkit-scrollbar": {
            width: "6px",
            height: "6px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(0, 0, 0, 0.35)",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "transparent",
          },
        }}
      >
        <List disablePadding>
          {events.map((evt, idx) => (
            <ListItem
              key={idx}
              disableGutters
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                py: 1.5,
                borderBottom: idx === events.length - 1 ? "none" : `1px solid ${theme.palette.divider}`,
              }}
            >
              <PlayButtonContainer>
                <PlayIcon />
              </PlayButtonContainer>
              <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                <Typography variant="body2" sx={{ fontWeight: "bold", color: "text.primary" }}>
                  {evt.type}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ display: "block", noWrap: true }}>
                  {evt.camera}
                </Typography>
              </Box>
              <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0 }}>
                {evt.time.split(" ")[0]}
              </Typography>
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default EventLog;
